<template>
</template>

<script>
export default {
	name:'com-table',
	props:{
		url:{type:String,default:''},
		data:{type:Array},
		search:{type:Object,default:()=>{}},
		searchTypes:{type:Boolean,default:false},
		nopagination:{type:Boolean,default:false},
		noborder:{type:Boolean,default:false},
		nostripe:{type:Boolean,default:false},
		noautowidth:{type:Boolean,default:false},
		noautobind:{type:Boolean,default:false},
		rowKey:{},
		treeProps:{type:Object,default:()=>{return {children:'children'}}},
		highlightCurrentRow:{},
		showHeader:{},
		rowClassName:{},
		rowStyle:{},
		cellClassName:{},
		cellStyle:{},
		headerRowClassName:{},
		headerRowStyle:{},
		headerCellClassName:{},
		headerCellStyle:{},
		pageFields:{type:Object,default:()=>{return {page:'page',rows:'rows'}}},
		dataFormat:{type:Function,default:(data)=>{
			return data;
		}},
	},
	created(){
		this.pageSize=this.defaultPageSize;
		if(this.data!=null){
			this.selfData=this.initDataFormat(this.data);
		}
		if(this.url!=''&&!this.noautobind){
			this.loadUrlData();
		}
		this.$options.render = createElement => {
			if(this.selfData==null){
				return;
			}
			
			var containers=[];
			var columns=[];
			
			var slots=this.$scopedSlots.default({data:{}});
			for(let i=0;i<slots.length;i++){
				let ctl=slots[i];
				if(ctl.tag==null)
					continue;
				//fixed:i==slots.length?'right':undefined
				var ctlType=ctl.tag.replace(/vue-component-\d.*?-/,'');
				if(ctlType=='ElTableColumn'){
					columns.push(ctl);
				}
				else{
					
					//fixed="right"
					//ctl.data.attrs['min-width']=200;
					
					var width=ctl.data.attrs.width;
					var minWidth=ctl.data.attrs['min-width'];
					var hasButton=false;
					if(ctlType=='ui-date'&&minWidth==null){
						if(ctl.componentOptions.propsData.type=='datetime'){
							minWidth=180;
						}
						else{
							minWidth=120;
						}
					}
					else if(ctlType=='ui-text'&&minWidth==null){
						switch(ctl.componentOptions.propsData.valueType){
							case 'idcard':
								minWidth=170;
								break;
							case 'phone':
								minWidth=115;
								break;
						}
					}
					else if(ctlType=='ui-template'&&i==slots.length-1&&width==null&&!this.noautowidth){
						var sumWidth=22;
						for(var c=0;c<ctl.componentOptions.children.length;c++){
							let child=ctl.componentOptions.children[c];
							if(child.tag==null)
								continue;
							if(child.tag.slice(-9)=='ui-button'){
								hasButton=true;
								if(child.componentOptions.children){
									sumWidth+=49+12*child.componentOptions.children[0].text.length;
									if(child.componentOptions.propsData.onlyicon!=null){
										sumWidth-=5;
									}
								}
								else{
									sumWidth+=73;//默认都是两个字12*2
									if(child.componentOptions.propsData.onlyicon!=null){
										sumWidth-=29;
									}
								}
								sumWidth+=14;
							}
						}
						width=sumWidth-14;
						//ctl.componentOptions.fixed="right";
					}
					else if(minWidth==null&&!this.noautowidth){
						minWidth=100;
					}
					
					if(ctlType=='ui-template'&&!hasButton){
						hasButton=ctl.componentOptions.children.some(p=>p.tag!=null&&p.tag.slice(-9)=='ui-button');
					}
					
					columns.push(createElement('el-table-column',{props:{
						label:ctl.data.attrs.label,
						width:width,
						minWidth:minWidth,
						fixed:ctl.data.attrs.fixed,
						'class-name':hasButton?'com-table-buttons-cell':undefined,
						//fixed:ctlType=='ui-template'&&i==slots.length-1?'right':undefined
					},scopedSlots:{
						default:props=>{
							let coms=[];
							let com=this.$scopedSlots.default({data:props.row})[i];
							var type=com.tag.replace(/vue-component-\d.*?-/,'');
							
							if(type=='ui-template'){
								for(var c=0;c<com.componentOptions.children.length;c++){
									let child=com.componentOptions.children[c];
									if(child.tag==null)
										continue;
									if(child.tag.slice(-9)=='ui-button'){
										child.componentOptions.propsData.size='mini';
									}
								}
							}
							if(com.componentOptions.propsData!=null){
								com.componentOptions.propsData.view='';
							}
							if(type=='ui-date'&&com.componentOptions.propsData.value){
								coms.push(createElement('i',{class:'el-icon-time'}));
							}
							else if(type=='ui-switch'){
								com.componentOptions.propsData.tag='';
							}
							else if(type=='ui-image'){
								com.componentOptions.propsData.size='mini';
							}
							
							coms.push(com);
							return createElement('div',{class:'com-table-cell'},coms);
						}
					}}));
				}
			}
			
			containers.push(createElement('div',{class:'com-table-frame'},[
				createElement('el-table',{
					props:{
						data:this.selfData,border:!this.noborder,stripe:!this.nostripe,height:'100%',
						rowKey:this.rowKey,treeProps:this.treeProps,defaultExpandAll:this.rowKey!=null?true:false,
						highlightCurrentRow:this.highlightCurrentRow,showHeader:this.showHeader,
						rowClassName:this.rowClassName,rowStyle:this.rowStyle,
						cellClassName:this.cellClassName,cellStyle:this.cellStyle,
						headerRowClassName:this.headerRowClassName,headerRowStyle:this.headerRowStyle,
						headerCellClassName:this.headerCellClassName,headerCellStyle:this.headerCellStyle
					},
					on:{
						'current-change':this.currentChange,
						'select':this.select,
						'select-all':this.selectAll,
						'selection-change':this.selectionChange
					},
					style:{
						position:'absolute'
					},
					ref:'table'
				},columns)
			]));
			if(this.url!=''&&this.total!=0&&!this.nopagination){
				var pageSizes=[];
				var addPageSize=(size,append)=>{
					if((size<=this.total||append)&&pageSizes.indexOf(size)==-1){
						pageSizes.push(size);
					}
				};
				addPageSize(5);
				addPageSize(10);
				addPageSize(20);
				addPageSize(50);
				addPageSize(100);
				addPageSize(this.defaultPageSize,true);
				
				containers.push(createElement('el-pagination',{props:{
					layout:'total,sizes,prev,pager,next,jumper',
					pageSizes:pageSizes,
					total:this.total,
					currentPage:this.currentPage,
					pageSize:this.pageSize,
					background:'',
				},
				on:{
					'update:currentPage':(val)=>{
						this.currentPage=val;
					},
					'update:pageSize':(val)=>{
						this.pageSize=val;
					},
					'size-change':()=>{
						this.loadUrlData();
					},
					'current-change':()=>{
						this.loadUrlData();
					},
				}}));
			}
			return createElement('div',{class:'com-table',ref:'component'},containers);
		};
	},
	data(){
		return {
			selfData:[],
			selection:[],
			defaultPageSize:20,
			currentPage:1,
			pageSize:0,
			total:0,
		};
	},
	mounted(){
	},
	watch:{
		selfData(val){
			this.$nextTick(()=>{
				this.$emit('databound',val);
			});
			this.$emit('update:data', val);
		},
		data(val){
			this.selfData=this.initDataFormat(val);
		},
		url(val){
			this.loadUrlData();
		},
		search(val){
			this.currentPage=1;
			this.pageSize=this.defaultPageSize;
			this.loadUrlData();
		},
	},
	methods:{
		getObjectValue(obj,name){
			var names=name.split('.');
			var output=obj;
			for(var i=0;i<names.length;i++){
				if(output==null)
					break;
				output=output[names[i]];
			}
			return output;
		},
		currentChange(row,oldRow){
			this.$emit('current-change',row,oldRow);
		},
		selectionChange(selection){
			this.selection=selection;
		},
		selectionChangeEvent(){
			this.$emit('selection-change',this.selection);
		},
		initDataFormat(data){
			let setTreeNode=(arr,parent)=>{
				for(let p=0;p<arr.length;p++){
					arr[p]._parent=parent;
					let children=arr[p][this.treeProps.children];
					if(this.rowKey!=null&&children&&children.length!=0){
						setTreeNode(children,arr[p]);
					}
				}
			};
			setTreeNode(data);
			return data;
		},
		select(selection,row){
			this.selection=selection;//执行顺序最晚，必须写这句不然数据项会滞后
			if(selection.indexOf(row)!=-1){
				this.setParentChecked(row);
				this.setChildrenChecked(row);
			}
			else{
				this.setChildrenChecked(row,false);
				this.setParentChecked(row,false);
			}
			this.selectionChangeEvent();
		},
		selectAll(selection){
			let selected=!this.selfData.some(p=>{
				return selection.indexOf(p)==-1;
			});
			for(let i=0;i<this.selfData.length;i++){
				this.setChildrenChecked(this.selfData[i],selected);
			}
			this.selectionChangeEvent();
		},
		setParentChecked(obj,selected=true){
			let node=obj._parent;
			while(node){
				if(selected){
					this.$refs.table.toggleRowSelection(node,selected);
				}
				else{
					if(node[this.treeProps.children].every(p=>this.selection.indexOf(p)==-1)){
						this.$refs.table.toggleRowSelection(node,selected);
					}
				}
				node=node._parent;
			}
		},
		setChildrenChecked(obj,selected=true){
			let children=obj[this.treeProps.children];
			if(this.rowKey!=null&&children&&children.length!=0){
				for(let i=0;i<children.length;i++){
					this.$refs.table.toggleRowSelection(children[i],selected);
					this.setChildrenChecked(children[i],selected);
				}
			}
		},
		toggleRowsSelection(cons,selected){
			let setTreeNode=(arr)=>{
				for(let p=0;p<arr.length;p++){
					let conResult=false;
					for(let i=0;i<cons.length;i++){
						let result=true;
						for(let name in cons[i]){
							if(cons[i][name]!=this.getObjectValue(arr[p],name)){
								result=false;
								break;
							}
						}
						if(result){
							conResult=true;
							this.$refs.table.toggleRowSelection(arr[p],selected);
							this.setParentChecked(arr[p]);
							break;
						}
					}
					if(!conResult){
						this.$refs.table.toggleRowSelection(arr[p],false);
					}
					let children=arr[p][this.treeProps.children];
					if(this.rowKey!=null&&children&&children.length!=0){
						setTreeNode(children);
					}
				}
			};
			setTreeNode(this.selfData);
			this.selectionChangeEvent();
		},
		toggleRowSelection(row,selected){
			this.$refs.table.toggleRowSelection(row,selected);
			this.select(this.selection,row);
		},
		clearSelection(){
			this.$refs.table.clearSelection();
			this.selectAll([]);
		},
		toggleAllSelection(){
			this.$refs.table.toggleAllSelection();
			this.selectAll(this.selection);
		},
		refresh(){
			this.loadUrlData();
		},
		getColumnsInfo(){
			var infos=[];
			var slots=this.$scopedSlots.default({data:{}});
			for(let i=0;i<slots.length;i++){
				let ctl=slots[i];
				if(ctl.tag==null||!(ctl.data.model||ctl.data.attrs&&ctl.data.attrs.field))
					continue;
				var field=ctl.data.attrs.field;
				if(!field){
					field=ctl.data.model.expression.split('.');
					field=field[field.length-1];
				}
				infos.push({field:field,label:slots[i].data.attrs.label});
			}
			return infos;
		},
		loadUrlData(){
			var paramTypes={};
			if(this.searchTypes){
				for(var name in this.search){
					paramTypes['_t_'+name]='like';
				}
			}
			var params=Object.assign(paramTypes,this.search);
			var pageParmas={};
			pageParmas[this.pageFields.page]=this.currentPage;
			pageParmas[this.pageFields.rows]=this.nopagination?10000:this.pageSize;
			this.$axios.get(this.url,{params:Object.assign(pageParmas,params)})
			.then(data=>{
				if(data.total!=null){
					this.total=data.total;
					this.selfData=this.initDataFormat(this.dataFormat(data.list));
				}
				else if(Array.isArray(data)){
					this.selfData=this.initDataFormat(this.dataFormat(data));
				}
				else{
					this.selfData=this.initDataFormat(this.dataFormat(data));
					//throw new Error('不支持的数据格式');
				}
			}).end();
		},
	},
}
</script>

<style lang="scss">
.el-pagination{border:1px solid #EBEEF5;padding:9px 10px;border-top:0;}
.com-table{
	flex-grow:1;display:flex;flex-direction:column;
	.com-table-frame{flex-grow:1;position:relative;}
	.com-table-cell{
		display:flex;align-items:center;
		>i{margin-right:5px;}
	}
	.com-table-buttons-cell{
		padding:10px 0;
	}
}
.el-table__header th{background:#FAFAFA;}
</style>
